
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "ArticleAllocation": [
      "EbomPartAllocation",
      "ManualArticleAllocation"
    ],
    "Check": [
      "ConfirmCheck",
      "FileUploadCheck",
      "NumericCheck",
      "StringCheck"
    ],
    "CheckI": [
      "ConfirmCheck",
      "FileUploadCheck",
      "NumericCheck",
      "StringCheck"
    ],
    "DAGNode": [
      "ModuleNode"
    ],
    "IArticle": [
      "Article",
      "EbomPart"
    ],
    "IArticleAllocation": [
      "EbomPartAllocation",
      "ManualArticleAllocation"
    ],
    "IStepUpload": [
      "ImageStepUpload",
      "VideoStepUpload"
    ],
    "IssueLink": [
      "ArticleIssueLink",
      "BOPIssueLink",
      "ModuleIssueLink",
      "SerialNumberIssueLink",
      "StepIssueLink"
    ],
    "IssueLinkI": [
      "ArticleIssueLink",
      "BOPIssueLink",
      "ModuleIssueLink",
      "SerialNumberIssueLink",
      "StepIssueLink"
    ],
    "StepUpload": [
      "ImageStepUpload",
      "VideoStepUpload"
    ],
    "TreeGraph": [],
    "TreeNode": [
      "StepNode"
    ],
    "UploadExtension": [
      "CsvExtension",
      "GenericExtension",
      "ImageExtension",
      "ModelExtension",
      "PdfExtension",
      "VideoExtension"
    ],
    "UploadUsageLocation": [
      "BOPUploadUsageLocation",
      "CheckUploadUsageLocation",
      "IconUploadUsageLocation",
      "IssueCommentUploadUsageLocation",
      "IssueUploadUsageLocation",
      "ProductConfigurationUploadUsageLocation",
      "ProductUploadUsageLocation",
      "StepImageUploadUsageLocation",
      "StepUploadUsageLocation",
      "ToolImageUploadUsageLocation"
    ],
    "UploadUsageLocationI": [
      "BOPUploadUsageLocation",
      "CheckUploadUsageLocation",
      "IconUploadUsageLocation",
      "IssueCommentUploadUsageLocation",
      "IssueUploadUsageLocation",
      "ProductConfigurationUploadUsageLocation",
      "ProductUploadUsageLocation",
      "StepImageUploadUsageLocation",
      "StepUploadUsageLocation",
      "ToolImageUploadUsageLocation"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ArticleAllocation": [
      "EbomPartAllocation",
      "ManualArticleAllocation"
    ],
    "Check": [
      "ConfirmCheck",
      "FileUploadCheck",
      "NumericCheck",
      "StringCheck"
    ],
    "CheckI": [
      "ConfirmCheck",
      "FileUploadCheck",
      "NumericCheck",
      "StringCheck"
    ],
    "DAGNode": [
      "ModuleNode"
    ],
    "IArticle": [
      "Article",
      "EbomPart"
    ],
    "IArticleAllocation": [
      "EbomPartAllocation",
      "ManualArticleAllocation"
    ],
    "IStepUpload": [
      "ImageStepUpload",
      "VideoStepUpload"
    ],
    "IssueLink": [
      "ArticleIssueLink",
      "BOPIssueLink",
      "ModuleIssueLink",
      "SerialNumberIssueLink",
      "StepIssueLink"
    ],
    "IssueLinkI": [
      "ArticleIssueLink",
      "BOPIssueLink",
      "ModuleIssueLink",
      "SerialNumberIssueLink",
      "StepIssueLink"
    ],
    "StepUpload": [
      "ImageStepUpload",
      "VideoStepUpload"
    ],
    "TreeGraph": [],
    "TreeNode": [
      "StepNode"
    ],
    "UploadExtension": [
      "CsvExtension",
      "GenericExtension",
      "ImageExtension",
      "ModelExtension",
      "PdfExtension",
      "VideoExtension"
    ],
    "UploadUsageLocation": [
      "BOPUploadUsageLocation",
      "CheckUploadUsageLocation",
      "IconUploadUsageLocation",
      "IssueCommentUploadUsageLocation",
      "IssueUploadUsageLocation",
      "ProductConfigurationUploadUsageLocation",
      "ProductUploadUsageLocation",
      "StepImageUploadUsageLocation",
      "StepUploadUsageLocation",
      "ToolImageUploadUsageLocation"
    ],
    "UploadUsageLocationI": [
      "BOPUploadUsageLocation",
      "CheckUploadUsageLocation",
      "IconUploadUsageLocation",
      "IssueCommentUploadUsageLocation",
      "IssueUploadUsageLocation",
      "ProductConfigurationUploadUsageLocation",
      "ProductUploadUsageLocation",
      "StepImageUploadUsageLocation",
      "StepUploadUsageLocation",
      "ToolImageUploadUsageLocation"
    ]
  }
};
      export default result;
    